<template>
  <v-dialog 
    :value="show" 
    @input="$emit('update:show', $event)"
    fullscreen 
    hide-overlay 
    transition="dialog-bottom-transition"
  >
    <v-card color="#141616">
      <v-toolbar class="mb-6" dark>
        <v-btn icon dark @click="$emit('update:show', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Σχετικά Δελτία Αποστολής</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-alert outlined type="info" v-if="currentRelateDA && currentRelateDA.length > 0">
          Επιλέξτε ένα από τα παρακάτω δελτία αποστολής για να δείτε το QR code.
        </v-alert>
        <v-alert outlined type="warning" v-if="!currentRelateDA || currentRelateDA.length === 0">
          Δεν υπάρχουν σχετικά δελτία αποστολής για αυτό το προϊόν.
        </v-alert>
        
        <div v-if="!currentRelateDA || currentRelateDA.length === 0" class="text-center my-4" style="color: #888;">
          Δεν υπάρχουν σχετικά δελτία αποστολής για αυτό το προϊόν.
        </div>

        <v-expansion-panels
          v-if="currentRelateDA && currentRelateDA.length > 0"
          accordion
        >
          <v-expansion-panel
            v-for="da in currentRelateDA"
            :key="da.NumberPar"
          >
            <v-expansion-panel-header class="px-2 py-2">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon :color="da.NumberPar ? 'success' : 'warning'">
                      {{ da.NumberPar ? 'mdi-check-circle' : 'mdi-clock-outline' }}
                    </v-icon>
                    {{ da.NumberPar ? `ΔΑ ${da.NumberPar}` : 'Σε αναμονή' }}
                    {{ formatDate(da.Hmerom) }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    MARK: {{ da.invoiceMark || '-' }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    ποσότητα: {{ da.Posot }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-expansion-panel-header>
            <v-expansion-panel-content style="padding: 0px; margin: 0px;">
              <v-alert dense outlined class="mt-2" style="font-size: 14px;" type="warning" v-if="!da.NumberPar">
                Το δελτίο αποστολής δεν έχει εκδοθεί ακόμα, ενδεχομένως να προέκυψε σφάλμα. Επικοινωνήστε με το γραφείο.
              </v-alert>
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Πελάτης</v-list-item-title>
                    <v-list-item-subtitle>{{ da.PartnerBrandName }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Διεύθυνση</v-list-item-title>
                    <v-list-item-subtitle>{{ da.BranchAddress }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div class="mt-2 pl-2">
                <vue-qrcode v-if="da.qrURL" :value="da.qrURL" :size="250" />
                <v-btn
                  class="mt-2"
                  color="primary"
                  :href="da.qrURL"
                  target="_blank"
                  text
                  small 
                  v-if="da.qrURL"
                >
                  Άνοιγμα QR URL
                  <v-icon right small>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrcode from 'qrcode.vue'
import moment from 'moment'

export default {
  name: 'SDARelatedDeliveries',
  components: {
    VueQrcode
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    currentRelateDA: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD/MM/YY')
    }
  }
}
</script> 